export default {
  'nav.categories': 'Categories',
  'nav.home': 'Home',
  'nav.shoppingGuide': 'Shopping Guide',
  'nav.review': 'Review',
  'nav.shipping': 'Shipping',
  'nav.safety': 'Safety',
  'nav.buyNow': 'Buy It Now',
  'nav.language': 'Language',

  'footer.tagline': 'An independent resource for finding products, checking QC and shopping smarter.',
  'footer.disclaimer': 'This website is an independent informational resource and is not affiliated with, endorsed by, or sponsored by USFans or any seller. Always verify information before ordering.',
  'footer.quickLinks': 'Quick Links',
  'footer.home': 'Home',
  'footer.guide': 'USFans Spreadsheet Guide',
  'footer.categories': 'Categories',
  'footer.rights': 'All rights reserved.',
  'footer.language': 'Language',

  'cta.exploreSpreadsheet': 'Explore USFans Spreadsheet',
  'cta.buyNow': 'Buy It Now',
  'cta.startGuide': 'Start With the Beginner Guide',
  'cta.browseCategories': 'Browse All Categories',
  'cta.readGuide': 'Read the Guide',
  'cta.readArticle': 'Read Guide',
  'cta.continueMain': 'Continue to the Main Website',
  'cta.readSafety': 'Read the Safety Guide',
  'cta.backHome': 'Back to Home',
};